import { Box, Tab } from '@mui/material';
import { SyntheticEvent, useEffect, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './DeliveryTracking.scss';
import { motion } from 'framer-motion';
import { BoxProps } from '@mui/material/Box';
import { JackInTheBox } from 'react-awesome-reveal';
import Trips from '../../../../../features/deliverytracking/pages/trips/Trips';
import CustomerDelivery from '../../../../../features/deliverytracking/pages/configurations/customerdelivery/CustomerDelivery';
import LoginRedirect from '../../../../components/loginredirect/LoginRedirect';

interface TabLabel {
  label: string;
  path: string;
  component: JSX.Element;
}

// Function for the management component:
function DeliveryTracking() {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState<string>('0');

  const tabLabels: TabLabel[] = [
    { label: 'Customers', path: 'customerdelivery', component: <CustomerDelivery /> },
    { label: 'Delivery Tracking', path: 'deliverytrackingtrips', component: <Trips /> }
  ];

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    const defaultPath = 'customerdelivery';
    const pathUrl = tabLabels.findIndex(tab => location.pathname.includes(tab.path));
    if (location.pathname === '/deliverytracking') {
      navigate(`/deliverytracking/${defaultPath}`);
    } else {
      setValue(pathUrl.toString());
    }
  }, [location.pathname, navigate, tabLabels]);

  const MotionBox = motion<BoxProps, any>(Box);
  return (
    <Box className='delivery-tracking-container'>
      <TabContext value={value}>
        <Box className='tab-context  animate__animated animate__slideInRight animate__fast'>
          <Box className='tab-list '>
            {/* Loop function for the tab names: */}
            <TabList
              onChange={handleChange}
              aria-label='lab API tabs example'
              variant='scrollable'
              allowScrollButtonsMobile
            >
              {tabLabels.map((tab, index) => (
                <Tab
                  key={index}
                  className='tab '
                  label={tab.label}
                  value={index.toString()}
                  component={Link}
                  to={`/deliverytracking/${tab.path}`}
                />
              ))}
            </TabList>
          </Box>
        </Box>

        <Box sx={{ height: `calc(100vh - 100px)`, overflow: 'hidden' }}>
          {/* Loop function for the tab name components: */}
          {tabLabels.map((tab, index) => (
            <TabPanel key={index} value={index.toString()}>
              {tab.component}
            </TabPanel>
          ))}
        </Box>

        <LoginRedirect />
      </TabContext>
    </Box>
  );
}

export default DeliveryTracking;
